module.exports = __webpack_public_path__ + "static/media/appointment-expiration.4eed8327.svg";